import { Typography, Row, Col } from "antd";
const { Text } = Typography;

// Компонент для горизонтального отображения поля просмотра
const HorizontalViewItem = ({label, children}) => (
    <div style={{ marginBottom: 16 }}>
        <Row align="middle" gutter={0}>
            <Col span={12}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <Text>{label}</Text>
                    <div style={{
                        flex: 1,
                        height: '1px',
                        backgroundColor: '#f5f5f5'
                    }}></div>
                </div>
            </Col>
            <Col span={12}>
                <Text>
                    {children}
                </Text>
            </Col>
        </Row>
    </div>
);

export default HorizontalViewItem;